import {getPrivateAxios} from '../../libs';
import {Guide} from './types';

/**
 *
 * @param guide
 */
export const fetchGuideUpdate = async (guide: Pick<Guide, 'id' | 'name' | 'description'>) => {
  const {data} = await getPrivateAxios().patch<Guide>(`/guides/${guide.id}`, guide);
  return data;
};
